/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CureItemToServiceUsage_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/cureItemToServiceUsages/:id', {},
        {
            query: {method: 'GET', isArray: true},
            get: {method: 'GET'},
            getDeleted: {method: 'GET', isArray: true, url: baseUrl + 'rest/cureItemToServiceUsages/deleted'}
        }
    );
}
]);

angular.module('FlexyBeautyApp.services').factory('CureItemToServiceUsage', ["CureItemToServiceUsage_Resource", "CureItemToServiceUsageData", "HumanResourceData", "ActivityData",
    function (CureItemToServiceUsage_Resource, CureItemToServiceUsageData, HumanResourceData, ActivityData) {

        var CureItemToServiceUsage = function (resource, cureItemToService) {
            this.id = null;
            this.isDeleted;
            this.cureItemToService = cureItemToService;
            this.usageTime = null;
            this.humanResource = null;
            this.bookingService = null;
            this.usedQuantity = 0;
            this.version = null;
            if (resource !== undefined && resource != null) {
                this.loadObject(resource);
            }
            CureItemToServiceUsageData.add(this);
        }
        CureItemToServiceUsage.prototype.loadObject = function (object) {
            if (!this.id)
                this.id = object.id;
            this.isDeleted = object.isDeleted;
            if (object.usageTime)
                this.usageTime = new Date(object.usageTime);
            this._humanResourceId = object.humanResourceId;
            this._bookingServiceId = object.bookingServiceId;
            this.usedQuantity = object.usedQuantity;
            if (object.version)
                this.version = object.version;
        }
        CureItemToServiceUsage.prototype.getObjectResource = function () {
            var rs = new CureItemToServiceUsage_Resource();
            if (this.cureItemToService)
                rs.cureItemToServiceId = this.cureItemToService.id;
            rs.id = this.id;
            rs.isDeleted = this.isDeleted;
            rs.usageTime = this.usageTime;
            if (this.humanResource)
                rs.humanResourceId = this.humanResource.id;
            if (this.bookingService)
                rs.bookingServiceId = this.bookingService.id;
            rs.usedQuantity = this.usedQuantity;
            return rs;

        }

        CureItemToServiceUsage.prototype.loadRef = function (isApplicationLoading) {
            this.humanResource = HumanResourceData.getById(this._humanResourceId);
            this.bookingService = ActivityData.getById(this._bookingServiceId, isApplicationLoading);
            if (this.bookingService)
                this.bookingService.cureItemToServiceUsage = this;
        }
        CureItemToServiceUsage.prototype.getId = function () {
            return this.id;
        }
        CureItemToServiceUsage.prototype.setId = function (id) {
            this.id = id;
        }
        return CureItemToServiceUsage;
    }
]);

angular.module('FlexyBeautyApp.services').factory('CureItemToServiceUsageSrv', ["$log", "ServerSrv", "CureItemToServiceUsage_Resource", "CureItemToServiceUsage", "UserActionData", "CureItemToServiceUsageData", "CureItemToServiceData",
    function ($log, ServerSrv, CureItemToServiceUsage_Resource, CureItemToServiceUsage, UserActionData, CureItemToServiceUsageData, CureItemToServiceData) {
        var cureItemToServiceUsageSrv =
            {};

        cureItemToServiceUsageSrv.save = function (cureItemToServiceUsage, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(cureItemToServiceUsageSrv.saveSync, cureItemToServiceUsage, successFunction, errorFunction);
        };
        cureItemToServiceUsageSrv.saveSync = function (cureItemToServiceUsage, successFunction, errorFunction) {
            //$timeout (function () {

            var CureItemToServiceUsageRes = cureItemToServiceUsage.getObjectResource();
            CureItemToServiceUsageRes.$save({}, //no params
                function (data) {
                    try {
                        if (cureItemToServiceUsage.id == null) {
                            cureItemToServiceUsage.setId(data.id);
                        }
                        if (!cureItemToServiceUsage.version || (data.version && data.version > cureItemToServiceUsage.version))
                            cureItemToServiceUsage.version = data.version;
                        /** @namespace data.supplierId */
                        if (data.supplierId && cureItemToServiceUsage.supplier)
                            cureItemToServiceUsage.supplier.id = data.supplierId;

                        if (successFunction != undefined)
                            successFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );

            //},2000)
        }
        cureItemToServiceUsageSrv.remove = function (cureItemToServiceUsage, successFunction, errorFunction) {
            CureItemToServiceUsageData.remove(cureItemToServiceUsage);
            ServerSrv.startSavingProcess(cureItemToServiceUsageSrv.removeSync, cureItemToServiceUsage, successFunction, errorFunction);
        };
        cureItemToServiceUsageSrv.removeSync = function (cureItemToServiceUsage, successFunction, errorFunction) {
            //$timeout (function () {

            var cureItemToServiceUsageRes = new CureItemToServiceUsage_Resource();
            cureItemToServiceUsageRes.$remove({id: cureItemToServiceUsage.getId()}, //params : id
                function (data) {
                    try {
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction != undefined)
                            successFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );

            //},2000)
        }
        cureItemToServiceUsageSrv.restore = function (cureItemToServiceUsage, successFunction, errorFunction) {
            CureItemToServiceUsageData.restore(cureItemToServiceUsage);
            ServerSrv.startSavingProcess(cureItemToServiceUsageSrv.restoreSync, cureItemToServiceUsage, successFunction, errorFunction);
        };
        cureItemToServiceUsageSrv.restoreSync = function (cureItemToServiceUsage, successFunction, errorFunction) {
            var cureItemToServiceUsageRes = cureItemToServiceUsage.getObjectResource();
            cureItemToServiceUsageRes.$save({}, //params : id
                function (data) {
                    try {
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction != undefined)
                            successFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        }
        cureItemToServiceUsageSrv.query = function (successFunction, errorFunction) {
            CureItemToServiceUsage_Resource.getDeleted(
                {}, //params
                function (data) {   //success

                    CureItemToServiceUsageData.deletedCureItemToServiceUsages = [];
                    for (var i = 0; i < data.length; i++)
                        new CureItemToServiceUsage(data[i]);//Auto Add to CureItemToServiceUsageData

                    if (successFunction !== undefined)
                        successFunction(CureItemToServiceUsageData.categoryRoot);
                },
                function (data) {   //failure
                    $log.error("CureItemToServiceUsage_Resource.getDeleted error");
                    $log.error(data);
                    if (errorFunction !== undefined)
                        errorFunction(data);

                });
        }
        cureItemToServiceUsageSrv.loadRef = function (isApplicationLoading) {
            var cureItemToServiceUsages = CureItemToServiceUsageData.indexCureItemToServiceUsages;
            for (var i = 0; i < cureItemToServiceUsages.length; i++)
                cureItemToServiceUsages[i].loadRef(isApplicationLoading);

        }
        cureItemToServiceUsageSrv.updateLocally = function (id, resource) {
            var cureItemToServiceUsage = CureItemToServiceUsageData.getById(id);
            if (cureItemToServiceUsage != null) {
                cureItemToServiceUsage.loadObject(resource);
            }
            return cureItemToServiceUsage
        };
        cureItemToServiceUsageSrv.addLocally = function (id, resource) {
            var cureItemToServiceUsage = CureItemToServiceUsageData.getById(id);
            if (cureItemToServiceUsage != null)
                cureItemToServiceUsage.loadObject(resource);
            else {
                cureItemToServiceUsage = new CureItemToServiceUsage(resource);
                cureItemToServiceUsage.id = id;
            }
            cureItemToServiceUsage.loadRef();
            if (resource.cureItemToServiceId) {
                var cureItemToService = CureItemToServiceData.getById(resource.cureItemToServiceId);
                if (cureItemToService)
                    cureItemToService.addCureItemToServiceUsage(cureItemToServiceUsage);
            }
            return cureItemToServiceUsage;


        };
        cureItemToServiceUsageSrv.removeLocally = function (id, resource) {
            var cureItemToServiceUsage = CureItemToServiceUsageData.getById(id);
            if (cureItemToServiceUsage != null) {
                //remove from cureItemToService
                if (cureItemToServiceUsage.cureItemToService)
                    cureItemToServiceUsage.cureItemToService.removeCureItemToServiceUsage(cureItemToServiceUsage);
            }
            return cureItemToServiceUsage;
        };

        return cureItemToServiceUsageSrv;
    }
]);

angular.module('FlexyBeautyApp.services').factory('CureItemToServiceUsageData', ["$log", function ($log) {
    var cureItemToServiceUsageData =
        {
            indexCureItemToServiceUsages: [], //Used as Index
            deletedCureItemToServiceUsages: []
        };
    cureItemToServiceUsageData.getById = function (cureItemToServiceUsageId) {
        for (var i = 0; i < this.indexCureItemToServiceUsages.length; i++)
            if (this.indexCureItemToServiceUsages[i].id == cureItemToServiceUsageId)
                return this.indexCureItemToServiceUsages[i];
        return null;
    }
    cureItemToServiceUsageData.getByIndex = function (servIndex) {
        if (servIndex >= 0 && servIndex < this.indexCureItemToServiceUsages.length) {
            return this.indexCureItemToServiceUsages[servIndex];
        } else
            return null;
    }
    cureItemToServiceUsageData.getIndexOf = function (cureItemToServiceUsage) {
        if (cureItemToServiceUsage)
            return this.indexCureItemToServiceUsages.indexOf(cureItemToServiceUsage);
        return -1;
    }
    cureItemToServiceUsageData.add = function (cureItemToServiceUsage) {
        this.indexCureItemToServiceUsages.push(cureItemToServiceUsage);
        if (cureItemToServiceUsage.isDeleted) {
            var index = this.deletedCureItemToServiceUsages.indexOf(cureItemToServiceUsage)
            if (index == -1)
                this.deletedCureItemToServiceUsages.push(cureItemToServiceUsage);
        }
        return this.indexCureItemToServiceUsages.length - 1;
    }
    cureItemToServiceUsageData.remove = function (cureItemToServiceUsage) //Soft Remove
    {
        var index = this.deletedCureItemToServiceUsages.indexOf(cureItemToServiceUsage);
        if (index == -1) {
            this.deletedCureItemToServiceUsages.push(cureItemToServiceUsage)
            cureItemToServiceUsage.isDeleted = true;
        }

    }
    cureItemToServiceUsageData.restore = function (cureItemToServiceUsage) //Soft Remove
    {
        var index = this.deletedCureItemToServiceUsages.indexOf(cureItemToServiceUsage);
        if (index != -1) {
            this.deletedCureItemToServiceUsages.splice(index, 1)
            cureItemToServiceUsage.isDeleted = false;
        }

    }
    cureItemToServiceUsageData.clear = function () {
        cureItemToServiceUsageData.indexCureItemToServiceUsages = [];
        cureItemToServiceUsageData.deletedCureItemToServiceUsages = [];
    }
    cureItemToServiceUsageData.getDeletedList = function () {
        return cureItemToServiceUsageData.deletedCureItemToServiceUsages;
    }

    return cureItemToServiceUsageData;
}
]);



// WEBPACK FOOTER //
// ./js/services/models/CureItemToServiceUsage.js